export const STORAGE = {

  TOKEN: "TOKEN",


  GROUP_DATA_LOCATION: "GROUP_DATA_LOCATION",
  DATA_SELECTTAXINVOICE: "DataSelectTaxinvoice",
  DATA_CREATEFULLTAX: "Datacreatefulltax",
  DATA_ABB: "DataABB",
  DATA_EDIT: "DataEdit",
  DATA_PREVIEW_TAXINVOICE: "DataPreviewTaxinvoice",
  DATA_CARDID: "datacardID",
  DATA_SEARCH_REPLACE: "DataSearchReplace",
  DATA_PREVIEW_REPLACE: "DataPreviewReplace",
  DATA_CHECK_REPLACE: "DatacheckReplace",
  DATA_KEY_CARDID: "DATA_KEY_CARDID",

  DATA_DELETE_FULLTAX: "DATA_DELETE_FULLTAX",
  DATA_LOG_ETAX: "DATA_LOG_ETAX",
  DATA_UNLOCK_ABB: "DATA_UNLOCK_ABB",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  userID: "userID",
  userBu: "userBu",
  userLoc: "userLoc",
  userRole: "userRole",
  SOURCE_SYSTEM: "source_system",
  modules: "modules",
  ActiveConfig: "ActiveConfig",
  B2C_TOKEN: "B2C_Token",

  // NO TAXINVOICE
  DATA_SELECT_NO_TAXINVOICE: "DataSelectNoTaxinvoice",
  DATA_ADD_NO__TAXINVOICE: "DataAbbnotaxinvoice",
  DATA_EDIT_NO__TAXINVOICE: "DataEditnotaxinvoice",
  DATA_PREVIEW_NO__TAXINVOICE: "DataPreviewNoTaxinvoice",
  DATA_SEARCH_NO__TAXINVOICE: "DataSearchNotaxinvoice",

  //CREDIT NOTE
  searchCreditNode: "searchCreditNode",
  verifyCreditNote: "verifyCreditNote",
  confirmCreditNote: "confirmCreditNote",
  viewDataIndx: "viewDataIndx",
  listdataCreditnote: "listdataCreditnote",
  sourceConnectionCreditNote: "sourceConnectionCreditNote",

  //CONFIG CUSTOMER
  editCusData: "editCusData",


  //PERMISSION
  PERMISSION_TOKEN: "PERMISSION_TOKEN",

  //version
  VERSION_API: "VERSION_API",
  VERSION_BE : "VERSION_BE"
};
